module.exports = __webpack_public_path__ + "static/media/1012807.301889f0.png";